import { TransactionWatcher, TransactionHash } from '@multiversx/sdk-core'
import { ApiNetworkProvider } from '@multiversx/sdk-network-providers'

export const checkTransaction = async (hash: string) => {
  const multiversxApi =
    process.env.REACT_APP_ENVIRONMENT === 'production'
      ? 'https://api.multiversx.com	'
      : 'https://devnet-api.multiversx.com'
  try {
    const processedHash = new TransactionHash(hash)
    const networkProvider = new ApiNetworkProvider(multiversxApi)
    const watcher = new TransactionWatcher(networkProvider)
    const transactionResult = await watcher.awaitCompleted({
      getHash: () => processedHash,
    })

    if (!transactionResult?.status?.isExecuted()) {
      return 'pending'
    }
    if (
      (transactionResult?.status?.isExecuted() && transactionResult?.status?.isFailed()) ||
      transactionResult?.status?.isInvalid()
    ) {
      return 'failed'
    }
    if (transactionResult?.status?.isExecuted() && !transactionResult?.status?.isFailed()) {
      return 'completed'
    }
    return 'pending'
  } catch (error) {
    console.error('Check transaction error', error)
    throw error
  }
}
